import React, { useState, useEffect} from 'react';
import { AddPostTags, GetAllPostTags, DeletePostTag } from '../services/posttagservice';

import slugify from 'slugify';

function PostTags({ postpk }) {

    const [tagslug, setTagSlug] = useState('');
    const [postTagOption, setPostTagOption] = useState([]);
    const [tag, setTag] = useState("");

    useEffect(() => {
        
        if (postpk != null) {
            fillPostTagData(postpk);
        }

    }, []);

    const handleTagChange = (event) => {
        setTag(event.target.value);
        setTagSlug(slugify(event.target.value, { lower: true, strict: true }));
    };
   
    const fillPostTagData = async (postpk) => {
        try {
            const dataList = await GetAllPostTags(postpk);
            const jsonDataList = JSON.parse(dataList);
            setPostTagOption(jsonDataList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const removeTag = async (postTagPk) => {
        DeletePostTag(postTagPk);
        await fillPostTagData(postpk);
    }

    const handleAddTag = async () => {
        const postTagBody = JSON.stringify({
            postpk: postpk,
            tagname:tag,
            paramlink:tagslug
        });
        
        await AddPostTags(postTagBody);
        await fillPostTagData(postpk);
        setTag('');
        setTagSlug('');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-9">
                    <div class="form-group">
                        <label for="txtTitle">Tag</label>
                        <input type="text" class="form-control" id="txtTags" onChange={handleTagChange} placeholder="Enter Tag" value={tag} />
                        <div className='slug'>{tagslug}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <div>
                            <label for="txtnobutton">&nbsp;</label>
                            <button type="button" class="btn btn-primary me-2 form-control" onClick={() => handleAddTag()}>Add Tag</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    {postTagOption && postTagOption.length > 0 ? (
                        postTagOption.map((option) => (
                            <div key={option.pk} data-value={option.pk} className="tag-item">
                                {option.tagname}
                                <div className="tag-remove" title="Remove Tag" onClick={() => removeTag(option.pk)}>X</div>
                            </div>
                        ))
                    ) : (
                        <div className="tag-item no-tags">No Tags Available</div>
                    )}

                </div>
            </div>
        </>
    );
}

export default PostTags;